module.exports = __webpack_public_path__ + "static/jack-kornfield-ec32bf9af195fabc3129dd7a990c4512.jpg";